import { styled } from '@mui/material';

const PREFIX = 'ActionButtonGroup';

export const actionButtonGroupClasses = {
  buttonGroup: `${PREFIX}-buttonGroup`,
};

export const ActionButtonGroupRoot = styled('div')(({ theme }) => ({
  [`& .${actionButtonGroupClasses.buttonGroup}`]: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));